import React from 'react';
import { Wrapper } from './PostListModule.style';
import { ModuleTitle } from '../homePage/moduleTitle/ModuleTitle';

interface PostListModuleProps {
  children: React.ReactNode;
  title: React.ReactNode;
  subtitle: React.ReactNode;
  viewMoreLink?: React.ReactNode;
}

const PostListModule: React.FC<PostListModuleProps> = ({
  children,
  title,
  subtitle,
  viewMoreLink,
}) => {
  return (
    <Wrapper>
      <ModuleTitle title={title} subtitle={subtitle} marginBottom="0" />
      {viewMoreLink && <div className="view-more">{viewMoreLink}</div>}
      <div className="post-list">{children}</div>
    </Wrapper>
  );
};

export default PostListModule;
